import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Linkedin } from "lucide-react";
import { LOGO_URL, OFFICES, PHONES, FIRM_EMAIL, ROTIMI_LINKEDIN } from "../data/firmContent";

export default function Footer() {
    return (
        <footer className="bg-[#0F172A] text-[#faf9f6]/90 mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img src={LOGO_URL} alt="RJ & Co" className="h-12 w-12 bg-white rounded-sm" />
                            <div>
                                <div className="font-serif-display text-2xl">Rotimi Jacobs &amp; Co</div>
                                <div className="font-mono-cap text-xs text-[#c5a059]">Legal Practitioners — Est. 1997</div>
                            </div>
                        </div>
                        <p className="mt-6 text-[15px] leading-relaxed text-[#faf9f6]/85 max-w-md">
                            Counsel to government, regulators, financial institutions and discerning private clients on
                            the most consequential matters in Nigeria.
                        </p>
                        <a
                            href={ROTIMI_LINKEDIN}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-linkedin-link"
                            className="mt-6 inline-flex items-center gap-2 text-sm text-[#c5a059] hover:text-[#faf9f6]"
                        >
                            <Linkedin className="w-4 h-4" /> Rotimi Jacobs, SAN — LinkedIn
                        </a>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-mono-cap text-xs text-[#c5a059] mb-4">{OFFICES.head.label}</div>
                        <address className="not-italic text-sm leading-relaxed text-[#faf9f6]/80">
                            {OFFICES.head.lines.map((l) => (
                                <div key={l}>{l}</div>
                            ))}
                        </address>
                        <div className="mt-6 font-mono-cap text-xs text-[#c5a059] mb-4">{OFFICES.abuja.label}</div>
                        <address className="not-italic text-sm leading-relaxed text-[#faf9f6]/80">
                            {OFFICES.abuja.lines.map((l) => (
                                <div key={l}>{l}</div>
                            ))}
                        </address>
                    </div>

                    <div className="md:col-span-2">
                        <div className="font-mono-cap text-xs text-[#c5a059] mb-4">Reach Us</div>
                        <ul className="space-y-2 text-sm">
                            {PHONES.map((p) => (
                                <li key={p} className="flex items-center gap-2">
                                    <Phone className="w-3.5 h-3.5 text-[#c5a059]" />
                                    <a href={`tel:${p.replace(/\s/g, "")}`} className="hover:text-[#c5a059]">
                                        {p}
                                    </a>
                                </li>
                            ))}
                            <li className="flex items-center gap-2 mt-3">
                                <Mail className="w-3.5 h-3.5 text-[#c5a059]" />
                                <a href={`mailto:${FIRM_EMAIL}`} className="hover:text-[#c5a059]">
                                    {FIRM_EMAIL}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="font-mono-cap text-xs text-[#c5a059] mb-4">Navigate</div>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/about" className="hover:text-[#c5a059]">About</Link></li>
                            <li><Link to="/practice-areas" className="hover:text-[#c5a059]">Practice Areas</Link></li>
                            <li><Link to="/publications" className="hover:text-[#c5a059]">Publications</Link></li>
                            <li><Link to="/gallery" className="hover:text-[#c5a059]">Gallery</Link></li>
                            <li><Link to="/blog" className="hover:text-[#c5a059]">Insights</Link></li>
                            <li><Link to="/contact" className="hover:text-[#c5a059]">Contact</Link></li>
                            <li><Link to="/login" className="hover:text-[#c5a059]">Counsel Login</Link></li>
                            <li><Link to="/privacy" className="hover:text-[#c5a059]">Privacy</Link></li>
                            <li><Link to="/terms" className="hover:text-[#c5a059]">Terms</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="rj-rule-gold mt-12 opacity-40" />
                <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-[#faf9f6]/60">
                    <div>© {new Date().getFullYear()} Rotimi Jacobs &amp; Co. All rights reserved.</div>
                    <div className="flex items-center gap-2">
                        <MapPin className="w-3.5 h-3.5 text-[#c5a059]" />
                        50 Queen Street, Lagos Mainland, Lagos 101245
                    </div>
                </div>
            </div>
        </footer>
    );
}
